/*----------------------------------
- NEWSLETTER PAGE: DECOY FIELD
----------------------------------*/

/**
 * The anti-bot field inside each capture of `/newsletter`, the hook's honeypot. Off-screen (`.wp-decoy`, the marketing
 * sheet's rule) rather than `hidden`, because bots skip hidden fields and a filled decoy is what tells the
 * gateway a submission is automated.
 *
 * @docs docs/features/newsletter
 * @rule The field name is `NEWSLETTER_HONEYPOT_FIELD` and the label avoids every token a password manager fills: an
 *       autofill match would silently drop a real subscriber.
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import type { JSX } from 'preact';

import { NEWSLETTER_HONEYPOT_FIELD } from '@uniquedomains/components/contracts/newsletter/public';

import { NEWSLETTER_PAGE_CONTENT } from '@/client/catalogs/landing/newsletter/pageContent';

/*----------------------------------
- TYPES
----------------------------------*/

type NewsletterDecoyProps = {
    /** The capture's email field id; the decoy takes `<fieldId>-<honeypot field>`. */
    fieldId: string;
    value: string;
    onInput: (value: string) => void;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

export default function NewsletterDecoy({ fieldId, value, onInput }: NewsletterDecoyProps) {
    const decoyId = `${fieldId}-${NEWSLETTER_HONEYPOT_FIELD}`;

    return (
        <div class="wp-decoy" aria-hidden="true">
            <label for={decoyId}>{NEWSLETTER_PAGE_CONTENT.form.decoyLabel}</label>
            <input
                id={decoyId}
                type="text"
                name={NEWSLETTER_HONEYPOT_FIELD}
                value={value}
                tabIndex={-1}
                autoComplete="off"
                onInput={(event: JSX.TargetedEvent<HTMLInputElement>) => onInput(event.currentTarget.value)}
            />
        </div>
    );
}
